import { render } from "./TestEventsWidget.vue?vue&type=template&id=0e11c17e"
import script from "./TestEventsWidget.vue?vue&type=script&lang=js"
export * from "./TestEventsWidget.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/felipe_admin_sr/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__